import { $http } from '../../stores/http';

type JSONValue = string | number | boolean | null | JSONObject | JSONArray;
interface JSONObject {
  [key: string]: JSONValue;
}
interface JSONArray extends Array<JSONValue> {}

async function check_import_schema_for_unknown_references(
  schema: JSONValue
): Promise<Array<String>> {
  const url = '/check_import_schema_for_unknown_references';
  // @ts-expect-error: data can be non nullable
  const response = await $http('POST', url, JSON.stringify(schema));
  const responseJSON = JSON.parse(response);

  return responseJSON;
}

export async function requireUserToSignOffUnknownReferences(
  schema_json: JSONValue
) {
  const unknownReferences =
    await check_import_schema_for_unknown_references(schema_json);

  if (unknownReferences.length === 0) return true;

  const message = `User Beware! This import file contains unknown references.\n\nIt is unlikely that this is intended, recommended action is to CANCEL\n\nPlease check the import file.\n\nUnknown References:\n\n${unknownReferences.join(
    '\n'
  )}`;

  return confirm(message);
}
